var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"fac-number"},[_vm._v("\n  掲載施設数"),_c('span',[_vm._v(_vm._s(_vm._f("number_format")(_vm.total)))]),_vm._v("件\n")])}
var staticRenderFns = []

export { render, staticRenderFns }